<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('EditAgentInfo')">
            <edit-legal-agent></edit-legal-agent>
          </vs-tab>
          <vs-tab
            :label="$t('UploadDocuments')"
            v-if="
              $tabHasPermission(
                'AssignDocument|UnAssignDocument|GetAgentDocuments|GetDocumentSettingsByPartyType'
              )
            "
          >
            <documents-upload mode="legal"></documents-upload>
          </vs-tab>
          <vs-tab :label="$t('RecipientInfo')">
            <recipient-info></recipient-info>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import EditLegalAgent from "./EditLegalAgent.vue";
import RecipientInfo from "../../Agents/RecipientInfo.vue";
import DocumentsUpload from "../DocumentsUpload.vue";

export default {
  components: {
    EditLegalAgent,
    RecipientInfo,
    DocumentsUpload,
  },
};
</script>
<style scoped></style>
